import { Button } from '@/components/ui/button';
import { formatCalendarDate } from './calendarNavigation';

interface CalendarDateFilterProps {
  date: string;
  onClear: () => void;
}

export function CalendarDateFilter({ date, onClear }: CalendarDateFilterProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-primary/30 bg-primary/5 px-3 py-2 text-sm">
      <p>
        Showing workouts for <span className="font-semibold">{formatCalendarDate(date)}</span>
      </p>
      <Button type="button" variant="ghost" size="sm" onClick={onClear}>
        Clear date filter
      </Button>
    </div>
  );
}
